import moment from 'moment';

import { MomentDateFormat } from '../MomentDateFormat';

export class LongTermSchedule {
    id = 0;
    contractId = 0;
    startDate = moment(new Date())
        .add(1, 'day')
        .format(MomentDateFormat.DateOnlyUTCHyphenated);
    endDate = moment(new Date())
        .add(2, 'day')
        .format(MomentDateFormat.DateOnlyUTCHyphenated);
    isPublished = false;
    crewId = 0;
    activeDays = [1, 2, 3, 4, 5];
    roadName = '';
    mayNotBePublishedBecauseStartsInThePast = false;
    leadEmployeeId = null;

    scheduleApplicationGroupCount = { applicationGroupId: 3, count: 0 };

    scheduleEquipmentGroupCounts = [];

    longTermScheduleContractPhases = [];
}

export const LongTermScheduleDayShifts = Object.freeze([
    { name: 'All', id: 2 },
    { name: 'Day', id: 0 },
    { name: 'Night', id: 1 },
]);

export const LongTermScheduleDayCancelOptions = {
    NextWorkingDay: 1,
    NextOpenDay: 2,
};

export const toEmployeeString = (employee) =>
    `${employee.lastName}, ${employee.firstName} (${employee.userName})`;

export const getDurationInDays = (longTermSchedule) => {
    if (
        moment(longTermSchedule.endDate).isBefore(
            longTermSchedule.startDate,
            'day'
        )
    ) {
        return 0;
    }

    const diffInDays = moment(longTermSchedule.endDate).diff(
        longTermSchedule.startDate,
        'days'
    );

    // 1 Jan 2025 -> 2 Jan 2025 should be treated as two days; moment treats it as one
    return diffInDays + 1;
};

const getHoursAndMinutes = (timePortion) => {
    if (!timePortion) {
        console.error(
            `[${timePortion}] is not recognized as a valid time portion.`
        );

        return { hour: 0, minute: 0 };
    }

    const splitEventValues = timePortion.split(':');

    return { hours: splitEventValues[0], minutes: splitEventValues[1] };
};

export const getEventDisplayDate = (eventDate, job) => {
    const displayDate = moment(eventDate).format(
        MomentDateFormat.WeekDayNameAndDate
    );

    if (!job?.startTime) {
        return displayDate;
    }

    const hoursAndMinutes = getHoursAndMinutes(job.startTime);

    return moment(eventDate)
        .add(hoursAndMinutes)
        .format(MomentDateFormat.WeekDayNameAndDateWithTime);
};

// same value is set in LongTermScheduleService.cs -> MAX_RESOURCES
export const MaxResourceCount = 50;

export const PseudoNavOptions = {
    Add: 'ADD',
    DivisionChange: 'DIVISION_CHANGE',
    ShiftChange: 'SHIFT_CHANGE',
    StateFilterChange: 'STATE_FILTER_CHANGE',
};

// C# version lives in All.cs
export const LongTermSchedulePseudoStates = {
    // these numbers don't map to a single state field, it's a bit more
    // context-dependent
    NotAssigned: 1,
    Assigned: 2,
    Published: 3,
    Released: 4,
};

export const DOW_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
